import './account.css';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import * as ReactGA from 'react-ga';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Analytics } from './analytics/analytics';
import { BillingPayments } from './billing-payments';
import { Candidates } from './candidates';
import { CompanyGroups } from './company-groups';
import { CompanyUsers } from './company-users';
import { GetStarted } from './get-started';
import { Jobs } from './jobs';
import { JobPage } from './jobs-v2/JobPage';
import { Loader } from './loader';
import { Profile } from './profile/profile';
import { SamlSecurity } from './saml-security';
import { SidebarV2 } from './sidebar-v2/sidebar-v2';
import { SourceKey } from './source-key';
import { JobPageRedirect } from 'components/account/jobs-v2/JobPageRedirect';
import { AmlMonitoringPage } from 'components/account/jobs-v2/dropdowns/AML/AmlMonitoringPage';
import { UpdateAccountInfoPage } from 'components/create-account';
import { VerificationPage } from 'components/verification-page';
import { isProduction } from 'config';
import { ACCOUNT_ADMIN_PERMISSIONS, isAuthorized, REVIEWER_PERMISSIONS } from 'security/authorization';
import { useGlobalState } from 'store/reducers/reducer';
import { getUserInfo } from 'store/sagas/sagas';
export const Account = () => {
    const { state, asyncDispatch } = useGlobalState();
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (isProduction) {
            ReactGA.initialize('UA-151415696-1');
            ReactGA.pageview(pathname + search);
        }
    }, []);
    useEffect(() => {
        if (!state.accessToken)
            navigate('/signin');
    });
    useEffect(() => {
        if (!state.accountGroups) {
            loadUserInfo();
        }
        else if (isLoading) {
            setIsLoading(false);
        }
    }, [state.accountGroups]);
    useEffect(() => {
        if (!state.user) {
            loadUserInfo();
        }
        else if (isLoading) {
            /*
             * already in from sign in / forget / sign up
             * clear loading
             */
            setIsLoading(false);
        }
    }, [state.user]);
    const loadUserInfo = () => {
        void asyncDispatch(getUserInfo()).finally(() => {
            setIsLoading(false);
        });
    };
    const isAccountAdmin = state.user
        ? isAuthorized(state.user, ACCOUNT_ADMIN_PERMISSIONS)
        : false;
    const isReviewer = state.user
        ? isAuthorized(state.user, REVIEWER_PERMISSIONS)
        : false;
    const accountHasAnalyticsAccess = !!state.account?.hasAnalyticsAccess;
    const [noScroll, setNoScroll] = useState(false);
    return isLoading ? (React.createElement(Loader, null)) : (React.createElement("div", { className: classNames('account u-flex-row', { noscroll: noScroll }) },
        React.createElement(SidebarV2, { toggleScroll: setNoScroll }),
        React.createElement("div", { className: "u-padding-medium u-flex-1 u-flex-column u-align-vertical-center content" },
            React.createElement(Routes, null,
                React.createElement(Route, { element: React.createElement(Profile, null), index: true }),
                isAccountAdmin && (React.createElement(React.Fragment, null,
                    React.createElement(Route, { element: React.createElement(CompanyUsers, null), path: "users" }),
                    React.createElement(Route, { element: React.createElement(CompanyGroups, null), path: "groups" }),
                    React.createElement(Route, { element: React.createElement(SourceKey, null), path: "key" }),
                    React.createElement(Route, { element: React.createElement(GetStarted, null), path: "get-started" }),
                    React.createElement(Route, { element: React.createElement(BillingPayments, null), path: "billing-payments" }),
                    React.createElement(Route, { element: React.createElement(SamlSecurity, null), path: "saml-security" }))),
                isReviewer && (React.createElement(React.Fragment, null,
                    React.createElement(Route, { element: React.createElement(Jobs, { basePath: "/account/jobs", isAdmin: false }), path: "jobs" }),
                    React.createElement(Route, { element: React.createElement(JobPageRedirect, null), path: "job/:id" }),
                    React.createElement(Route, { element: React.createElement(JobPage, null), path: "jobs/:id" }),
                    React.createElement(Route, { element: React.createElement(AmlMonitoringPage, null), path: "jobs/:id/monitoring" }),
                    React.createElement(Route, { element: React.createElement(Candidates, null), path: "candidates" }))),
                accountHasAnalyticsAccess && isReviewer && (React.createElement(Route, { element: React.createElement(Analytics, null), path: "analytics" })),
                React.createElement(Route, { element: React.createElement(VerificationPage, null), path: "needs-verification" }),
                React.createElement(Route, { element: React.createElement(UpdateAccountInfoPage, null), path: "update-account-info" }),
                React.createElement(Route, { element: React.createElement(Navigate, { replace: true, to: "/account/jobs" }), path: "*" })))));
};
